import { render, staticRenderFns } from "./editPoll.vue?vue&type=template&id=2dd7f194&scoped=true&"
import script from "./editPoll.vue?vue&type=script&lang=js&"
export * from "./editPoll.vue?vue&type=script&lang=js&"
import style0 from "./editPoll.vue?vue&type=style&index=0&id=2dd7f194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7f194",
  null
  
)

export default component.exports